import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, List, ListItem, ListItemText, Grid } from '@material-ui/core';
import { FHEContainer, FHEContainerScroll, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { SvgRemote } from 'data/common/iconsvg';
import { getRemoteDetails } from '../../data/Remote/actions';

class RemoteDetail extends PureComponent {
    static propTypes = {
        getRemoteDetails: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        Remote: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            RemoteFrames: {}
        };
    }

    componentDidMount() {
        this.getRemoteDetails();
    }

    getRemoteDetails = () => {
        const { getRemoteDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        getRemoteDetails(match.params.remoteId)
            .then(frames => {
                this.setState({
                    RemoteFrames: frames,
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };

    renderDataFrames = () => {
        const { RemoteFrames } = this.state;
        const { classes } = this.props;

        const frames = [];
        if (Object.keys(RemoteFrames).length > 0) {
            {
                Object.keys(RemoteFrames).map(code => {
                    let frame = RemoteFrames[code];
                    frames.push(
                        <ListItem component="li" key={code} className={classes.frameListItem}>
                            <ListItemText primary={code} secondary={frame} className={classes.listItemTrame} />
                        </ListItem>
                    );
                });
            }
        } else {
            frames.push(<div>{Translator.translate('Remote.details.emptyFrame')}</div>);
        }

        return (
            <div className={classes.containerFrames}>
                <List component="ul" dense>
                    {frames}
                </List>
            </div>
        );
    };
    renderChildren = () => {
        const { loading } = this.state;
        const { Remote } = this.props;
        return (
            <Fragment>
                <FHETitle title={`${Remote.get('brand')} - ${Remote.get('ref')}`} Icon={SvgRemote} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={Remote.get('userEmail')} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.brand')} itemContent={Remote.get('brand')} />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.details')} />
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.tempMin')} itemContent={Remote.get('tempMin')} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.tempMax')} itemContent={Remote.get('tempMax')} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.ventilationMax')}
                                    itemContent={Remote.get('ventilationMax')}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.dataFrames')} />
                    <FHEContainerForm loading={loading} onRender={this.renderDataFrames} />
                </FHEContainerScroll>
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;

        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getRemoteDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const users = state.environments.myfhe.data.Users.get('list');
    const Remote = state.environments.myfhe.data.Remote.getIn(['list', props.match.params.remoteId], new Map());
    const masterId = Remote.getIn(['userId'], '');

    return {
        Remote: Remote.setIn(['userEmail'], users.getIn([masterId && masterId.toString(), 'email'], '')),
        initialized: state.environments.myfhe.data.Remote.get('initialized')
    };
}

const styles = () => ({
    containerFrames: {
        maxHeight: 300,
        overflow: 'auto'
    },
    frameListItem: {
        padding: 0
    },
    listItemTrame: {
        maxWidth: '100%',
        overflowWrap: 'break-word'
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getRemoteDetails }, dispatch)
    )(withStyles(styles, { withTheme: true })(RemoteDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/Remote/details.js